import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Images/logo-w.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Forgotpassword = () => {
    const [formData, setFormData] = useState({
        email: '',
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false); // Loading state for button
    const [message, setMessage] = useState(''); // Success or error message for the user
    const navigate = useNavigate(); // Navigate function to redirect

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation for email
        const validationErrors = {};
        if (!formData.email) validationErrors.email = 'Email is required';

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setLoading(true); 
        setMessage(''); 

        try {
            const response = await axios.post('https://rvapi.emedha.in/auth/api/forgot-password', formData);

            if (response.status === 200) {
                setMessage(response.data.message); 
                setFormData({ email: '' }); 
            }
        } catch (error) {
            setLoading(false); 
            if (error.response) {
                setMessage(error.response.data.error); 
            } else {
                setMessage('Something went wrong. Please try again.');
            }
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center min-vh-100"
            style={{
                background: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)',
                padding: '20px',
            }}
        >
            <div
                className="p-4"
                style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
                    width: '100%',
                    maxWidth: '400px',
                }}
            >
                <div className="text-center">
                    <img src={A1} alt="Logo" style={{ width: '150px', marginBottom: '15px' }} />
                    <h2 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
                        Forgot Password
                    </h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label" style={{ fontWeight: '500' }}>
                            Email Address
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-control"
                            placeholder="Enter your email"
                        />
                        {errors.email && <div className="text-danger">{errors.email}</div>}
                    </div>

                    {message && (
                        <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`} role="alert">
                            {message}
                        </div>
                    )}

                    <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Sending Reset Link...' : 'Send Reset Link'}
                        </button>
                    </div>
                </form>

                <div className="mt-3 text-center">
                    <a href="/" className="text-decoration-none text-primary me-3">
                        Back to Login
                    </a>
                </div>

                <div className="text-center mt-4" style={{ fontSize: '12px', color: '#777' }}>
                    <p>&copy; 2025 E-medha technologies. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default Forgotpassword;
